module.exports = "/_next/static/images/louisiana-69921b3dae68d0f8d181b01c23f7cfe7.svg";